"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  route: {
    "home": "首页",
    "dashboard": "门户展示",
    "onlineDev": "在线开发",
    "onlineDev-webDesign": "功能设计",
    "onlineDev-appDesign": "移动设计",
    "onlineDev-dataReport": "报表设计",
    "onlineDev-dataScreen": "大屏设计",
    "onlineDev-visualPortal": "门户设计",
    "generator": "代码生成",
    "generator-webForm": "功能表单",
    "generator-appForm": "移动表单",
    "generator-flowForm": "流程表单",
    "system": "系统管理",
    "system-sysConfig": "系统配置",
    "system-notice": "系统公告",
    "system-task": "系统调度",
    "system-cache": "系统缓存",
    "system-log": "系统日志",
    "system-monitor": "系统监控",
    "system-icons": "系统图标",
    "system-language": "翻译管理",
    "system-menu": "系统菜单",
    "system-area": "行政区划",
    "system-billRule": "单据模板",
    "systemData": "数据应用",
    "systemData-dataSource": "数据连接",
    "systemData-dataModel": "数据建模",
    "systemData-dataSync": "数据同步",
    "systemData-dataBackup": "数据备份",
    "systemData-dataInterface": "数据接口",
    "systemData-dictionary": "数据字典",
    "systemData-map": "数据地图",
    "weChat": "微信配置",
    "weChat-mpConfig": "公众号配置",
    "weChat-mpMenu": "公众号菜单",
    "weChat-mpUser": "公众号用户",
    "weChat-mpMessage": "公众号消息",
    "weChat-mpMaterial": "公众号素材",
    "weChat-qyhConfig": "企业号配置",
    "weChat-qyDepartment": "企业号组织",
    "weChat-qyUser": "企业号用户",
    "weChat-qyMessage": "企业号消息",
    "permission": "系统权限",
    "permission-organize": "组织管理",
    "permission-department": "部门管理",
    "permission-position": "岗位管理",
    "permission-user": "用户管理",
    "permission-role": "角色管理",
    "permission-authorize": "权限管理",
    "permission-userOnline": "在线用户",
    "workFlow": "工作流程",
    "workFlow-flowEngine": "流程设计",
    "workFlow-flowLaunch": "我发起的",
    "workFlow-flowTodo": "待办事宜",
    "workFlow-flowDone": "已办事宜",
    "workFlow-flowCirculate": "抄送事宜",
    "workFlow-entrust": "流程委托",
    "workFlow-flowMonitor": "流程监控",
    "extend-graphDemo": "图表示例",
    "extend-graphDemo-echartsBar": "E-柱状图",
    "extend-graphDemo-echartsPie": "E-饼状图",
    "extend-graphDemo-echartsBarAcross": "E-横状条形图",
    "extend-graphDemo-echartsGauge": "E-仪表图",
    "extend-graphDemo-echartsLineArea": "E-线形图",
    "extend-graphDemo-echartsScatter": "E-散点图",
    "extend-graphDemo-echartsCandlestick": "E-K线图",
    "extend-graphDemo-echartsLineBar": "E-折柱混合图",
    "extend-graphDemo-echartsTree": "E-树形图",
    "extend-graphDemo-echartsFunnel": "E-漏斗图",
    "extend-graphDemo-highchartsScatter": "H-散点图",
    "extend-graphDemo-highchartsWordcloud": "H-词云图",
    "extend-graphDemo-highchartsLine": "H-线性图",
    "extend-graphDemo-highchartsArea": "H-面积图",
    "extend-graphDemo-highchartsGauge": "H-仪表图",
    "extend-graphDemo-highchartsBellcurve": "H-贝尔曲线",
    "extend-graphDemo-highchartsFunnel": "H-漏斗图",
    "extend-graphDemo-highchartsBullet": "H-子弹图",
    "extend-graphDemo-highchartsColumn": "H-柱状图",
    "extend-graphDemo-highchartsPie": "H-饼状图",
    "extend-tableDemo": "表格示例",
    "extend-tableDemo-commonTable": "普通表格",
    "extend-tableDemo-statisticsTable": "表格统计",
    "extend-tableDemo-lockTable": "表格锁定",
    "extend-tableDemo-groupingTable": "表格分组",
    "extend-tableDemo-redactTable": "表格编辑",
    "extend-tableDemo-complexHeader": "复杂表头",
    "extend-tableDemo-mergeTable": "表格合并",
    "extend-tableDemo-printTable": "表格打印",
    "extend-tableDemo-extension": "延伸扩展",
    "extend-tableDemo-treeTable": "树形表格",
    "extend-tableDemo-postilTable": "表格批注",
    "extend-tableDemo-tableTree": "表格树形",
    "extend-tableDemo-signTable": "表格标记",
    "extend-formDemo": "表单示例",
    "extend-formDemo-verifyForm": "表单验证",
    "extend-formDemo-verifyForm1": "表单验证1",
    "extend-formDemo-fieldForm1": "表单字段1",
    "extend-formDemo-fieldForm2": "表单字段2",
    "extend-formDemo-fieldForm3": "表单字段3",
    "extend-formDemo-fieldForm4": "表单字段4",
    "extend-formDemo-fieldForm5": "表单字段5",
    "extend-formDemo-fieldForm6": "表单字段6",
    //生产品信息设定
    "productInfo": "生产品信息设定",
    "extend": "扩展应用",
    "extend-bigData": "百万数据",
    "extend-importAndExport": "导入导出",
    "extend-signet": "电子签章",
    "extend-signature": '电子签名',
    "extend-schedule": "日程安排",
    "extend-email": "邮件收发",
    "extend-document": "知识管理",
    "extend-documentPreview": "文档预览",
    "extend-barCode": "条码示例",
    "extend-printData": "打印示例",
    "extend-map": "地图示例",
    "extend-order": "订单管理",
    "extend-projectGantt": "项目管理",
    "moreMenu": "更多...",
    "dataReport": "报表示例",
    "reportBI": "大屏示例"
  },
  navbar: {
    profile: '个人信息',
    feedback: '反馈问题',
    about: '关于平台',
    lockScreen: '锁住屏幕',
    documentation: '帮助文档',
    logOut: '退出系统',
    notice: '消息',
    chat: '聊天',
    setting: '设置'
  },
  login: {
    title: '账户密码登录',
    scanTitle: 'APP扫码登录',
    codeTitle: '手机验证登录',
    logIn: '登录',
    username: '请输入用户名',
    password: '请输入密码',
    rule: '子账户规则：手机号@账户 例：18577778888@101001',
    version: '版本',
    upper: '大写已锁定',
    scanTip: 'APP扫码登录',
    accountTip: '请输入账号',
    passwordTip: '请输入密码',
    mobile: '请输入手机号',
    rightMobile: '请输入正确的手机号',
    smsCode: '请输入验证码',
    getCode: '获取验证码',
    reSend: '重新发送',
    company: '请输入公司名',
    contacts: '请输入联系人'
  },
  tagsView: {
    refresh: '刷新',
    close: '关闭',
    closeOthers: '关闭其它',
    closeAll: '关闭所有'
  },
  settings: {
    mode: '导航模式',
    classic: '侧边导航',
    functional: '顶部导航',
    plain: '简约导航',
    blend: '混合导航',
    lightOrDark: '颜色区块',
    dark: '暗黑模式',
    lightWhite: '亮白模式',
    theme: '主题颜色',
    blue: '经典蓝',
    purple: '玫紫',
    azure: '湛蓝',
    ocean: '海洋',
    green: '生机',
    yellow: '丰收',
    orange: '阳橙',
    red: '热情',
    otherSet: '其他设置',
    tagsView: '多页签开启模式',
    tagsViewIcon: '多页签显示图标',
    language: '显示多语言选择',
    search: '显示页面搜索框',
    cache: '多页签缓存页面'
  },
  common: {
    addBtn: '新建',
    editBtn: '编辑',
    delBtn: '删除',
    moreBtn: '更多',
    search: '查询',
    reset: '重置',
    refresh: '刷新',
    columnSettings: '列设置',
    fullScreen: '全屏',
    outFullScreen: '退出全屏',
    confirmButton: '确 定',
    cancelButton: '取 消',
    delTip: '此操作将永久删除该数据, 是否继续？',
    loadingText: '数据加载中',
    noData: '暂无数据',
    noPerTip: '暂无权限',
    tipTitle: '提示',
    prev: '上一步',
    next: '下一步',
    keyWord: '关键词',
    enterKeyword: '请输入关键词查询',
    organization: '组织机构'
  },
  Organize: {
    addCompany: '新建公司',
    editCompany: '编辑公司'
  },
  department: {
    addDepartment: '新建部门',
    editDepartment: '编辑部门'
  },
  position: {
    newPost: '新建岗位',
    editPost: '编辑岗位',
    postMember: '岗位成员',
    postPermission: '岗位权限'
  },
  user: {
    addUser: '新建用户',
    editUser: '编辑用户',
    resetPassword: '重置密码',
    userPermission: '用户权限'
  },
  role: {
    addRole: '新建角色',
    editRole: '编辑角色',
    roleMember: '角色成员',
    rolePermission: '角色权限'
  },
  authorize: {
    operation: '操作',
    checkAll: '全部勾选',
    deselectAll: '取消全选',
    expandAll: '展开所有',
    foldAll: '折叠所有',
    menuPermission: '菜单权限',
    buttonPermission: '按钮权限',
    listPermission: '列表权限',
    formPermission: '表单权限',
    dataPermission: '数据权限',
    selectRoles: '选择角色'
  },
  userOnline: {
    cancelAccountTip: '确定要注销该账号?',
    forcedOffline: '强制下线'
  }
};